module.exports = __webpack_public_path__ + "img/05-top-img.93d3e7b2.png";